import {
  useCallback, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import type { ModalProps } from '~/modal/modalType.enum';
import { DataLayerEditorModalContainer } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/modals/dataLayerEditorModal.container';
import { mapSettingsDataLayersUpdateDataLayer } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.actionCreators';
import {
  useMapSettingsBoundaryGroupsPerDataLayersSelector, useMapSettingsDataLayersInstancesSelector,
} from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.selectors';
import type {
  DataLayerData, DataLayerId,
} from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const DataLayerEditModalContainer = ({
  dataLayerId,
  ...modalProps
}: ModalProps<{
  dataLayerId: DataLayerId;
}>) => {
  const dispatch = useDispatch();
  const allDataLayers = useMapSettingsDataLayersInstancesSelector();
  const boundaryGroupPerLayer = useMapSettingsBoundaryGroupsPerDataLayersSelector();

  const dataLayer = allDataLayers.find((layer) => layer.id === dataLayerId);
  const boundaryGroupId = boundaryGroupPerLayer[dataLayerId];

  const handleSubmit = useCallback((dataLayerData: DataLayerData) => {
    dispatch(mapSettingsDataLayersUpdateDataLayer(dataLayerId, dataLayerData));
    modalProps.onClose();
  }, [dataLayerId, dispatch, modalProps]);

  useEffect(() => {
    if (!dataLayer || !boundaryGroupId) {
      modalProps.onClose();
    }
  }, [dataLayer, boundaryGroupId, modalProps]);

  if (!dataLayer || !boundaryGroupId) {
    return null;
  }

  return (
    <DataLayerEditorModalContainer
      initialData={dataLayer.data}
      boundaryGroupId={boundaryGroupId}
      onSubmit={handleSubmit}
      {...modalProps}
    />
  );
};
